<template>
    <el-menu default-active="1-4-1" class="el-menu-vertical-demo"  background-color="#545c64"  text-color="#fff"  active-text-color="#ffd04b" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
        <h3 style="text-align:center">红名单管理系统</h3>
        <template v-for="item in list">
            <template >
                <el-submenu :index="item.index" v-if="item.children" :key="item.index">
                    <template slot="title"><i :class="item.icon"></i>{{item.title}}</template>
                    <el-menu-item-group>
                        <el-menu-item :index="item1.index" @click="goPage(item1)" v-for="item1 in item.children" :key="item1.index">{{item1.title}}</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                 <el-menu-item :index="item.index" v-else  @click="goPage(item)" :key="item.index">
                    <i :class="item.icon"></i>
                    <span slot="title">{{item.title}}</span>
                </el-menu-item>
            </template>
           
        </template>
    </el-menu>
</template>
<style lang="less" scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
  }
  .el-menu{
        height:100%;
        border:none;
        h3{
            color:#fff;
            text-align:center;
            line-height:48px;
        }
  }
</style>

<script>
import {getNavigation} from '@/utils/api'
  export default {
    data() {
      return {
        isCollapse: false,
        menuList:[
            // {
			// 	title:'小程序用户列表',
			// 	icon:'el-icon-user-solid',
			// 	index:'0',
            //     path:'/Wxuser'
			// },
			// {
			// 	title:'名单列表',
			// 	icon:'el-icon-user-solid',
			// 	index:'1',
            //     path:'/Warehousing'
			// },
            // {
			// 	title:'红名单列表',
			// 	icon:'el-icon-user-solid',
			// 	index:'2',
            //     path:'/Warehouse'
			// },
            // {
			// 	title:'评价审核',
			// 	icon:'el-icon-star-on',
			// 	index:'3',
            //     path:'/Stock'
			// },
            //  {
			// 	title:'点赞管理',
			// 	icon:'el-icon-thumb',
			// 	index:'4',
            //     path:'/QueryPricing'
			// },
            //  {
			// 	title:'统计管理',
			// 	icon:'el-icon-s-data',
			// 	index:'5',
            //     path:'/CashFlows'
			// },
            // {
			// 	title:'岗位分类管理',
			// 	icon:'el-icon-user-solid',
			// 	index:'6',
            //     path:'/JobWork'
			// },
            // {
			// 	title:'标签管理',
			// 	icon:'el-icon-s-flag',
			// 	index:'7',
            //     path:'/LabelManagement'
			// },
            // {
			// 	title:'系统设置',
			// 	icon:'el-icon-menu',
			// 	index:'8',
            //     children:[
			// 		{
			// 			title:'用户管理',
			// 			index:'8-1',
            //             path:'/UserGl'
			// 		},
            //         {
			// 			title:'角色管理',
			// 			index:'8-2',
            //             path:'/RoleManagement'
			// 		}
			// 	]
			// },
		]
      };
    },
    props:{
        list:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        goPage(item) {
           //console.log(item)
           this.$router.push(item.path).catch(err => err)
            //this.$emit('getType',item.index)  
        },
    },
    mounted(){
        let user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            userId:user.uid
        }
        getNavigation(param).then(res=>{
           // console.log(res)
            this.menuList=res;
        })
    },
    computed:{

    }
  }
</script>


// WEBPACK FOOTER //
// src/components/comAside.vue